<template>
  <li
    :class="[
      'pagination__item',
      {
        'pagination__item--active': isActive
      }
    ]"
    @click.prevent="emits('click', page)"
  >
    <span
      v-if="isActive"
      class="pagination__link"
    >
      {{ page }}
    </span>

    <a
      v-else
      class="pagination__link"
      :href="link"
      @click.prevent
    >
      {{ page }}
    </a>
  </li>
</template>

<script lang="ts" setup>
type Props = {
  page: number
  link: string
  isActive: boolean
}

type Emits = {
  (e: 'click', page: number): void
}

defineProps<Props>()

const emits = defineEmits<Emits>()
</script>
